import { Search } from "lucide-react";
import type { ToolToolbarProps } from "./types";
import styles from "./ToolPage.module.css";
export function ToolToolbar({
  search,
  filters,
  sort,
  resultLabel,
}: ToolToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <label className={styles.search}>
        <Search size={18} aria-hidden="true" />
        <input
          type="search"
          aria-label={search.label}
          placeholder={`${search.label}…`}
          value={search.value}
          onChange={(e) => search.onChange(e.target.value)}
        />
      </label>
      {filters}
      {sort}
      {resultLabel && (
        <span className={styles.resultLabel} aria-live="polite">
          {resultLabel}
        </span>
      )}
    </div>
  );
}
